import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-error-message-modal',
    templateUrl: './error-message-modal.component.html',
    styleUrls: ['./error-message-modal.component.scss']
})
export class ErrorMessageModalComponent {

    @Input() showErrorMessageModal: boolean = false;
    @Input() errorTitle: string = '';
    @Input() errorSummary: string = '';
    @Input() primaryCtaText: string = '';
    @Input() secondaryCtaText: string = '';
    @Input() imageSrc: string = ''; // this should be relative to this component

    @Output() onPrimaryCtaClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() onSecondaryCtaClicked: EventEmitter<any> = new EventEmitter<any>();

    handlePrimaryCtaClick() {
        this.showErrorMessageModal = false;
        this.onPrimaryCtaClicked.emit();
    }

    handleSecondaryCtaClick() {
        this.showErrorMessageModal = false;
        this.onSecondaryCtaClicked.emit();
    }
}
